import { useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Capabilities from "@/components/site/Capabilities";
import Services from "@/components/site/Services";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";
import EnquiryModal from "@/components/site/EnquiryModal";
import IntroSplash from "@/components/site/IntroSplash";
import ScrollProgress from "@/components/site/ScrollProgress";
import FloatingDock from "@/components/site/FloatingDock";
import Process from "@/components/site/Process";
import Coverage from "@/components/site/ServiceAreas";
import WhyTafra from "@/components/site/WhyTafra";
import Licenses from "@/components/site/Licenses";
import Careers from "@/components/site/Careers";
import MobileStickyBar from "@/components/site/MobileStickyBar";

const ComingSoon = () => {
  const [modal, setModal] = useState({ open: false, mode: "contact", defaultMessage: "" });

  const openContact = (defaultMessage = "") =>
    setModal({ open: true, mode: "contact", defaultMessage });
  const openAssessment = () =>
    setModal({ open: true, mode: "site_assessment", defaultMessage: "" });
  const close = () => setModal((m) => ({ ...m, open: false }));

  return (
    <div
      className="min-h-screen pb-20 md:pb-0"
      style={{ background: "var(--bg)", color: "var(--text)" }}
      data-testid="coming-soon-page"
    >
      <ScrollProgress />
      <IntroSplash />
      <Header onOpenContact={openContact} onOpenAssessment={openAssessment} />
      <main>
        <Hero onOpenContact={openContact} onOpenAssessment={openAssessment} />
        <Marquee />
        <Licenses />
        <Capabilities />
        <Process />
        <Services onOpenContact={openContact} />
        <WhyTafra />
        <Coverage />
        <Careers />
        <ContactSection
          onOpenContact={openContact}
          onOpenAssessment={openAssessment}
        />
      </main>
      <Footer />
      <EnquiryModal
        open={modal.open}
        onClose={close}
        mode={modal.mode}
        defaultMessage={modal.defaultMessage}
      />
      <FloatingDock onOpenContact={() => openContact()} />
      <MobileStickyBar />
    </div>
  );
};

export default ComingSoon;
